"use client";
import React from "react";

export default function ShareButton({ title, url, text }) {
  const shareUrlFunAll = async () => {
    const shareData = {
      title: title,
      text: text,
      url: url,
    };

    // If Web Share API available
    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (error) {
        console.error("Share failed:", error);
      }
    } else {
      // Fallback: copy URL
      navigator.clipboard.writeText(url);
      alert("Link copied!");
    }
  };

  return (
    <div
      className="share_icon"
      onClick={shareUrlFunAll}
      data-title={title}
      data-text={text}
      data-url={url}
      role="button"
    >
      <span className="material-symbols-outlined">share</span>
    </div>
  );
}
